import { useCallback, useState } from "react";
import styles from "./StatisticsView.module.scss";
import { View, ViewHeader } from "@/components";
import { getRollingBounds } from "../../_utils/statisticsDateFilter.util";
import { useStatisticsDashboard } from "../../_hooks/useStatisticsDashboard.hook";
import type { StatisticsDateRangePickerChange } from "../statistics-date-range-picker";
import { StatisticsBar, StatisticsGeoPanels } from "../";

export const StatisticsView = () => {
  const [bounds, setBounds] = useState(() => getRollingBounds(7));
  const { overview, prevOverview, geoPoints, loading, error } =
    useStatisticsDashboard(bounds);

  const handleBoundsChange = useCallback(
    (value: StatisticsDateRangePickerChange) => {
      setBounds((prev) => {
        if (
          prev.start.getTime() === value.start.getTime() &&
          prev.end.getTime() === value.end.getTime()
        ) {
          return prev;
        }
        return { start: value.start, end: value.end };
      });
    },
    [],
  );

  return (
    <View>
      <div className={styles["comp"]}>
        <ViewHeader
          heading="Statistics"
          description="Track your most important metrics and performance indicators in one place.<br />Use this section to monitor trends and business results."
        />

        <StatisticsBar
          onBoundsChange={handleBoundsChange}
          overview={overview}
          prevOverview={prevOverview}
          loading={loading}
          error={error}
        />

        <StatisticsGeoPanels geoPoints={geoPoints} />
      </div>
    </View>
  );
};
